import { Box, styled } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useState } from "react";
import { toast } from "sonner";
import { LAButton } from "../LAButton/LAButton";
import Toaster from "../Toaster/Toaster";
import { ReportTemplate } from "../../templates/ReportTemplate/ReportTemplate";
import { COLORS } from "../../theme/colors";
import {
  downloadInvoice,
  getDownloadErrorMessage,
} from "../../services/invoiceDownload";

export const PdfGenerator = ({ disabled, reportTMP, invoiceId = null }) => {
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);
  const hasInvoice = invoiceId !== null && invoiceId !== undefined;

  const handleDownloadInvoice = async () => {
    if (!hasInvoice) {
      return;
    }

    try {
      setIsDownloadingInvoice(true);
      await downloadInvoice(invoiceId);
    } catch (error) {
      const message = await getDownloadErrorMessage(error);
      toast.custom((t) => <Toaster t={t} message={message} />);
    } finally {
      setIsDownloadingInvoice(false);
    }
  };

  return (
    <ButtonContiner>
      {hasInvoice ? (
        <LAButton
          variant="primary"
          disabled={isDownloadingInvoice}
          loading={isDownloadingInvoice}
          text="Download invoice"
          onClick={handleDownloadInvoice}
        />
      ) : null}
      {disabled ? (
        <LAButton disabled={disabled} text={"Save as PDF"} />
      ) : (
        <PDFLinkStyled
          document={<ReportTemplate reportTMP={reportTMP} />}
          fileName={`report_(${reportTMP.id}).pdf`}
          style={{ color: disabled ? COLORS.NEUTRAL4 : COLORS.NEUTRAL0 }}
        >
          {({ loading }) => {
            return (
              <LAButton
                disabled={disabled || loading}
                text={loading ? "Loading Report" : "Save as PDF"}
              />
            );
          }}
        </PDFLinkStyled>
      )}
    </ButtonContiner>
  );
};

const ButtonContiner = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1.5),
  width: "auto",
  flexWrap: "nowrap",
}));
export const PDFLinkStyled = styled(PDFDownloadLink)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.COLORS.NEUTRAL0,
  ...theme.typography.body2,
  [theme.breakpoints.down("md")]: {
    ...theme.typography.body5,
  },
}));
